import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body, Typography } from "../styled";

const BirthAndLanguage: FC = () => {
  return (
    <Box mt={1}>
      <Header>
            <Typography ml={5} mb={1}>Место рождения </Typography>
            <TextField
                label="Город, село, деревня"
                variant="outlined"
                size="small"
                sx={{ mb: 1, width: "800px" }}
            />
            <TextField
                label="Район"
                variant="outlined"
                size="small"
                sx={{ mb: 1, width: "800px" }}
            />
            <TextField
                label="Область (край, республика)"
                variant="outlined"
                size="small"
                sx={{ mb: 1, width: "800px" }}
            />
            <TextField
                label="Страна"
                variant="outlined"
                size="small"
                sx={{ width: "800px" }}
            />
      </Header>
      <Body>
            <Typography ml={5} mb={1}>Владение языками</Typography>
            <TextField
                label="Родной"
                variant="outlined"
                size="small"
                sx={{ width: "300px", mb: 1 }}
            />
            {/* <Box display='flex' justifyContent=''> */}
                <TextField
                    label="Другой язык "
                    variant="outlined"
                    size="small"
                    sx={{ width: "300px", mb: 1, mr: 2 }}
                />
                <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="A1(Начальный)"
                />
                <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="A2(Выше Начального)"
                />
                <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="B1(Средний начальный)"
                />
                <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="B2(Средний)"
                />
                <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="C1(Продвинутый)"
                />
                <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="C2(Профессиональный)"
                />
            {/* </Box> */}
      </Body>
    </Box>
  );
};

export default BirthAndLanguage;
